var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 37.35,
    y1: 65.96,
    x2: 75.91,
    y2: 28.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3267ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3062b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2b569f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#22417f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203b75"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 74.5,
    y1: 104.37,
    x2: 81.32,
    y2: 102.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b76d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3871c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2f63b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e62ae"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 74.61,
    y1: 13.19,
    x2: 98.44,
    y2: 116.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73c8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6fc1f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#64afe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5595df"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 124.11H6.14A6.13 6.13 0 01.34 116L37.26 8a6.13 6.13 0 015.8-4.15h29.56a6.13 6.13 0 015.8 8.15L41.5 120a6.14 6.14 0 01-5.8 4.11z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.21 124.11H77.57a2.61 2.61 0 01-1.78-.7L35.73 86a2.62 2.62 0 011.78-4.53h51.71a2.61 2.61 0 011.78.7l34.9 32.57a5.4 5.4 0 01-3.69 9.37z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.66 116L90.74 8a6.13 6.13 0 00-5.8-4.15H43.18A6.15 6.15 0 0149 8l36.91 108a6.14 6.14 0 01-5.81 8.12h41.76a6.13 6.13 0 005.8-8.12z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.be7ca4796274c46646705461e2f6c5bb.svg";
export { ForwardRef as ReactComponent };